import { FONTS } from '../../config/app-config';
import React, { useMemo } from 'react';
import { Box, Breadcrumbs, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useTheme } from '@mui/material/styles';

function BreadCrumbs({
    tocData,
    selectedArticleId,
    selectedRelease,
    handleArticleSelect,
}) {
    const theme = useTheme();
    const darkMode = theme.palette.mode === 'dark';

    const breadcrumbItems = useMemo(() => {
        if (!Array.isArray(tocData) || tocData.length === 0 || !selectedArticleId) {
            return [];
        }
        const findNodePath = (nodes, targetId) => {
            for (const node of nodes) {
                if (node._id === targetId) {
                    return [node];
                }
                if (node.children?.length) {
                    const childPath = findNodePath(node.children, targetId);
                    if (childPath) {
                        return [node, ...childPath];
                    }
                }
            }
            return null;
        };
        return findNodePath(tocData, selectedArticleId) || [];
    }, [tocData, selectedArticleId]);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                position: 'sticky',
                top: 0,
                backgroundColor: 'background.default',
                color: 'text.primary',
                zIndex: theme.zIndex.appBar - 1,
                boxShadow: '0 4px 8px -2px rgba(0, 0, 0, 0.5)',
                p: 1.5,
                width: '100%',
                minHeight: '48px',
            }}
        >
            <Breadcrumbs
                aria-label="breadcrumb"
                separator={
                    <NavigateNextIcon
                        fontSize="small"
                        sx={{ color: darkMode ? '#888' : theme.palette.text.disabled }}
                    />
                }
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    '& .MuiBreadcrumbs-separator': { mx: 0.5 },
                    '& a': {
                        fontFamily: FONTS.body,
                        fontWeight: 400,
                        color: darkMode ? theme.palette.text.primary : theme.palette.text.secondary,
                        textDecoration: 'none',
                        px: 0.5,
                        py: 0.25,
                        fontSize: '12px',
                        borderRadius: 1,
                        transition: 'background-color 0.2s',
                        '&:hover': {
                            backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : theme.palette.action.hover,
                            color: darkMode ? theme.palette.text.primary : theme.palette.primary.main,
                        },
                        lineHeight: '1.2',
                    },
                    '& .MuiTypography-root': {
                        fontFamily: FONTS.body,
                        fontWeight: 500,
                        color: 'text.primary',
                        fontSize: '12px',
                        px: 0.5,
                        py: 0.25,
                        lineHeight: '1.2',
                    },
                }}
            >
                {breadcrumbItems.map(item => (
                    <Link
                        key={item._id}
                        href={`?${selectedRelease.toSearchParams({ articleId: item._id })}`}
                        underline="none"
                        onClick={event => {
                            event.preventDefault();
                            handleArticleSelect(item._id);
                        }}
                    >
                        {item.title}
                    </Link>
                ))}
            </Breadcrumbs>
        </Box>
    );
}

export default BreadCrumbs;

